<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <apcam-file-upload
        [uploadWorkerUrl]="uploadWorkerUrl()"
        [multiple]="data.multiple"
        [allowedMIMETypes]="data.allowedMIMETypes ?? []"
        [hideSubmitButton]="data.hideSubmitButton ?? false"
        (filesEvent)="localFilesEvent($event)"></apcam-file-upload>
</apcam-shared-dialog-shell>
